module.exports = __webpack_public_path__ + "media/images/sound3-f19477ea77e5ed8bc91c502eebcb1dba.png";